import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const TeamCard = loadable(() => pMinDelay(import('./TeamCard'), 300), {
  fallback: <Loading />
});

const AsyncTeamCard = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: 'full',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green hide-betslip hide-sticky-navigation`
      },
      title: 'Bilyoner.com | Takım Kartı'
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <TeamCard { ...props }/>
    </ApplicationLayout>
  );
};

AsyncTeamCard.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncTeamCard;
